module.exports = __webpack_public_path__ + "static/media/inbox.882f80c5.svg";